import { CodeReferenceBlockConfigurationRecord } from "models/view-models/block-configurations/code-reference-block-configuration-record";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface CodeReferenceBlockConfigurationUpdatePathParams {
    configurationId: number;
}

export interface CodeReferenceBlockConfigurationUpdatePutParams {
    sectionId?: number;
    isEnhancedContentDisplayed?: boolean;
}

const resourceEndpoint: string =
    "blocks/configurations/codereference/:configurationId";
const resourceType = CodeReferenceBlockConfigurationRecord;

const CodeReferenceBlockConfigurationService = {
    useUpdate: ServiceHookFactory.useUpdateFromPutParams<
        CodeReferenceBlockConfigurationRecord,
        CodeReferenceBlockConfigurationUpdatePutParams,
        CodeReferenceBlockConfigurationUpdatePathParams
    >(resourceType, resourceEndpoint),
};

export default CodeReferenceBlockConfigurationService;
